import { LmIconFilledImageVideoColorPalette, LmIconOutlineImageVideoColorPalette } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconCreationUnitsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? (
    <LmIconOutlineImageVideoColorPalette {...rest} />
  ) : (
    <LmIconFilledImageVideoColorPalette {...rest} />
  );

export default IconCreationUnitsCommon;
